import { Link } from "react-router-dom";
import { genres } from "@/mocks/movies";

const genreIcons: Record<string, string> = {
  动作: "ri-boxing-line",
  科幻: "ri-rocket-line",
  剧情: "ri-movie-2-line",
  爱情: "ri-heart-line",
  悬疑: "ri-eye-line",
  犯罪: "ri-police-car-line",
  奇幻: "ri-magic-line",
  冒险: "ri-compass-line",
  动画: "ri-palette-line",
  武侠: "ri-sword-line",
  家庭: "ri-home-heart-line",
  惊悚: "ri-ghost-line",
  励志: "ri-fire-line",
  赛车: "ri-speed-up-line",
};

export default function QuickCategories() {
  return (
    <section className="mx-auto w-full max-w-screen-xl px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按类型浏览
          </h2>
          <p className="mt-2 text-sm text-foreground-600">从你喜欢的类型出发，快速找到心仪影片</p>
        </div>
        <Link
          to="/category"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex"
        >
          全部分类
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </Link>
      </div>

      <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-7 md:gap-4">
        {genres.map((g) => (
          <Link
            key={g}
            to={`/category?genre=${encodeURIComponent(g)}`}
            className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-2 py-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${genreIcons[g] ?? "ri-film-line"} text-xl`}></i>
            </span>
            <span className="text-xs font-medium text-foreground-800 md:text-sm">{g}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}